/**
 * Placeholder dates for the Regulamento screen. Replace with real sources
 * (API, CMS, or realities-info) when available.
 */
export const REGULATION_KEY_DATES = [
  {
    label: "Prazo para inscrição",
    dateText: "até 15 de junho de 2026",
  },
  {
    label: "Prazo para envio de desafios e cursos",
    dateText: "até 15 de junho de 2026",
  },
  {
    label: "Prazo lista classificados",
    dateText: "até 30 de junho de 2026",
  },
] as const;
